module.exports = __webpack_public_path__ + "img/retrospect-139-mobile.ca5c297b.jpg";